module.exports = __webpack_public_path__ + "static/img/yeswecan0035.a4db134.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0035.png
// module id = 610
// module chunks = 1